import { createFileRoute } from '@tanstack/react-router';
import { queryClient } from '@/lib/utils/queryClient';
import { AdminDocumentsTab } from '../../../-components/AdminDocumentsTab';
import { adminDocumentsQueryOptions } from '../../../-hooks/useAdminDocuments';

export const Route = createFileRoute(
  '/management/documents/(pages)/(list)/archived/',
)({
  // Off the URL rather than a fixed first page, so a deep link with a sort
  // or filter prefetches the rows it will actually show.
  loaderDeps: ({ search }) => ({
    page: search.page ?? 1,
    limit: search.limit ?? 50,
    ...(search.sort !== undefined ? { sort: search.sort } : {}),
    ...(search.filters !== undefined ? { filters: search.filters } : {}),
  }),
  // Swallowed on purpose: the loader is a prefetch, and letting it reject
  // hands the route to the router's error boundary, which hides the tab's own
  // "Could not load" banner. Matches the other management lists.
  loader: ({ deps }) =>
    queryClient
      .ensureQueryData(
        adminDocumentsQueryOptions({ ...deps, isArchived: true }),
      )
      .catch(() => undefined),
  component: ArchivedDocumentsPage,
});

function ArchivedDocumentsPage() {
  return <AdminDocumentsTab isArchived={true} />;
}
